<template>
    <div class="story-1">
        <div class="st-1-left-container animated fadeIn 0.5s">
            <div class="chart-container">
                <svg width="100%" viewBox="-10 -30 120 120">
                    <path d="M5 50 a50 50 50 1 1 90 0" stroke="rgba(255,255,255, 0.3)" stroke-width="7"
                          stroke-linecap="round" fill-opacity="0"/>
                    <path d="M5 50 a50 50 20 1 1 90 0" stroke="#6f6f6f" stroke-width="4" stroke-linecap="round"
                          class="path" fill-opacity="0" :class="{ 'dash-it' : storyIndex >= 0}"/>
                    <path d="M5 50 a50 50 20 1 1 90 0" stroke="#ff6600" stroke-width="4" stroke-linecap="round"
                          class="path" fill-opacity="0" :class="{ 'dash-it' : storyIndex >= 0 && storyIndex !== 4}"/>
                    <path d="M5 50 a50 50 20 1 1 90 0" stroke="#1d0417" stroke-width="4" stroke-linecap="round"
                          class="path" fill-opacity="0"
                          :class="{ 'dash-it' : storyIndex >= 0 && storyIndex !== 4, 'step-1' : storyIndex >= 1 && storyIndex !== 4}"/>
                    <path d="M5 50 a50 50 20 1 1 90 0" stroke="purple" stroke-width="4" stroke-linecap="round"
                          class="path" fill-opacity="0"
                          :class="{ 'dash-it' : storyIndex >= 0 && storyIndex !== 4, 'step-1' : storyIndex >= 1 && storyIndex !== 4, 'step-2' : storyIndex >= 2 && storyIndex !== 4 }"/>
                    <path d="M5 50 a50 50 20 1 1 90 0" stroke="#00bfed" stroke-width="4.1" stroke-linecap="round"
                          class="path" fill-opacity="0"
                          :class="{ 'dash-it' : storyIndex >= 0, 'step-1' : storyIndex >= 1, 'step-2' : storyIndex >= 2, 'step-3' : storyIndex >= 3, 'step-4' : storyIndex >= 4 }"/>
                </svg>
                <div class="st-image-container animated fadeIn delay-1s">
                    <img src="@/assets/img/story_1_images/1.png">
                </div>
            </div>
            <div class="chart-indicator">
                <transition enter-active-class="animated fadeIn delay-1s" leave-active-class="animated fadeOut">
                    <ChartIndicator v-if="storyIndex === 0" :computed-props="chartIndicators[0]"/>
                </transition>
                <transition enter-active-class="animated fadeIn delay-1s" leave-active-class="animated fadeOut">
                    <ChartIndicator v-if="storyIndex === 1" :computed-props="chartIndicators[1]"/>
                </transition>
                <transition enter-active-class="animated fadeIn delay-1s" leave-active-class="animated fadeOut">
                    <ChartIndicator v-if="storyIndex === 1" :computed-props="chartIndicators[2]"/>
                </transition>
                <transition enter-active-class="animated fadeIn delay-1s" leave-active-class="animated fadeOut">
                    <ChartIndicator v-if="storyIndex === 2" :computed-props="chartIndicators[3]"/>
                </transition>
                <transition enter-active-class="animated fadeIn delay-1s" leave-active-class="animated fadeOut">
                    <ChartIndicator v-if="storyIndex === 2" :computed-props="chartIndicators[4]"/>
                </transition>
                <transition enter-active-class="animated fadeIn delay-1s" leave-active-class="animated fadeOut">
                    <ChartIndicator v-if="storyIndex > 2" :computed-props="chartIndicators[5]"/>
                </transition>
            </div>

            <div class="chart-indicator-mobile">
                <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                    <div v-if="storyIndex >= 0" class="chart-indicator-mobile-indicator">
                        <span style="background-color: #00bfed;"/>
                        <p>Su</p>
                    </div>
                </transition>
                <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                    <div v-if="storyIndex >= 1 && storyIndex !== 4" class="chart-indicator-mobile-indicator">
                        <span style="background-color: #ff6600;"/>
                        <p>Yeryüzü Tatlı Suyu</p>
                    </div>
                </transition>
                <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                    <div v-if="storyIndex >= 2 && storyIndex !== 4" class="chart-indicator-mobile-indicator">
                        <span style="background-color: #1d0417;"/>
                        <p>Buzul + Yeraltı Suyu</p>
                    </div>
                </transition>
                <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                    <div v-if="storyIndex >= 3 && storyIndex !== 4" class="chart-indicator-mobile-indicator">
                        <span style="background-color: purple;"/>
                        <p>Kullanılabilir su</p>
                    </div>
                </transition>
            </div>
        </div>
        <div class="st-1-right-container animated fadeIn">
            <div class="st-1-story">
                <transition enter-active-class="animated fadeIn"
                            leave-active-class="animated fadeOut" mode="out-in">
                    <p v-if="storyIndex >= 0" :key="storyIndex">{{ storySections[storyIndex].text }}</p>
                </transition>
            </div>
            <div class="story-button-container">
                <div v-if="storyDone" class="next-story">Bölüm 2</div>
                <ButtonBlueBackground v-if="storyDone" :text="'BİR İNSAN GÜNDE SADECE 2 LT’mi SU TÜKETİR?'" :to="'/02'"
                                      class="animated fadeIn"/>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from "../main";
    import ButtonBlueBackground from "../components/ButtonBlueBackground";
    import ChartIndicator from "../components/ChartIndicator";

    export default {
        name: "Story1",
        data() {
            return {
                storyDone: false,
                storySections: [
                    {'text': 'Dünyanın yüzeyinin %74’ü su ile kaplı ama… ', 'duration': 5},
                    {'text': 'Tatlı Su Oranı sadece %2,5', 'duration': 5},
                    {'text': 'Tatlı suyun sadece %1.2’si yeryüzünde', 'duration': 10},
                    {'text': 'Kalan tatlı suyun ise sadece \n %21’ini kullanabiliyoruz', 'duration': 10},
                    {
                        'text': 'Aslında dünyadaki suyun sadece %0,0063 yani\n100.000’de 6’sını kullanabiliyoruz.',
                        'duration': 10
                    }
                ],
                chartIndicators: {
                    "0": {
                        "container": "right: 155px; top: 42px;",
                        "line": "width: 38px; transform: rotate(-45deg);",
                        "textPos": "top: -55px; left: 40px;",
                        "text": "Su\n%74"
                    },
                    "1": {
                        "container": "right: 103px; top: 75px;",
                        "line": "width: 40px; transform: rotate(-25deg);",
                        "textPos": "top: -45px; left: 50px;",
                        "text": "Tuzlu Su\n %97,5"
                    },
                    "2": {
                        "container": "right: 48px; top: 260px;",
                        "line": "width: 40px; transform: rotate(0deg);",
                        "textPos": "top: -29px; left: 55px;",
                        "text": "Tatlı Su\n %2.5"
                    },
                    "3": {
                        "container": "right: 45px; top: 245px;",
                        "line": "    width: 36px;     transform: rotate(-18deg);",
                        "textPos": "width: 140px; top: -35px; left: 50px;",
                        "text": "Buzul + Yeraltı  Suyu\n%98,2"
                    },
                    "4": {
                        "container": "right: 61px; top: 295px;",
                        "line": "width: 30px; transform: rotate(0deg);",
                        "textPos": "width: 120px; right: -166px; bottom: -34px;",
                        "text": "Yeryüzü Tatlı Suyu\n%1.2’si"
                    },
                    "5": {
                        "container": "right: 61px; top: 295.4px;",
                        "line": "width: 40px; transform: rotate(0deg);",
                        "textPos": "top: -15px;     left: 55px;     width: 150px;",
                        "text": "Kullanılabilir Su"
                    }
                },
                storyIndex: -1,
                storyInterval: null,
            }
        },
        watch: {
            storyIndex(value) {
                value === 1 ? EventBus.$emit('story-background', 'show-dune-picture') : EventBus.$emit('story-background', 'hide-dune-picture');
                this.storyInterval = setTimeout(() => {
                    if (this.storyIndex < this.storySections.length - 1) {
                        this.storyIndex++;
                    } else {
                        this.storyDone = true;
                        clearInterval(this.storyInterval);
                    }
                }, this.storySections[this.storyIndex].duration * 1000);
            },
            storyDone(value) {
                value ? EventBus.$emit('story-done', { story : 1, value : true}) : EventBus.$emit('story-done', { story : 1, value : false });
            }
        },
        mounted() {
            setTimeout(() => {
                this.$store.commit('changeStory',1);
            }, 1000);
            EventBus.$emit('menu-status', false);
            this.$store.commit('navigationStatus', 'story');
            EventBus.$on('restart-story', () => {
                this.storyIndex = -1;
                this.storyDone = false;
                setTimeout(() => {
                    this.storyIndex++;
                }, 2000);
            });
        },
        created() {
            setTimeout(() => {
                this.storyIndex++;
            }, 2000);
        },
        beforeDestroy() {
            if (!(this.$route.name).includes('Story')) {

                EventBus.$emit('destroy-sequence');
            }
        },
        destroyed() {
            clearInterval(this.storyInterval);
        },
        components: {
            ChartIndicator,
            ButtonBlueBackground
        }
    }
</script>

<style lang="scss">
    .story-1 {
        display: flex;
        min-height: 580px;

        .st-1-left-container {
            position: relative;
            margin: 25px;

            .chart-container {
                width: 450px;
                height: auto;
                transform: rotateY(180deg);

                @media only screen and (max-device-width: 768px) {
                    transform: rotateY(180deg) scale(1.5);
                    margin-bottom: 135px;
                }

                .path {
                    stroke-dasharray: 270;
                    stroke-dashoffset: 270;
                    transition: stroke-dashoffset 1s ease-in-out;

                    &.dash-it {
                        stroke-dashoffset: 110;

                        &.step-1 {
                            stroke-dashoffset: 250;
                        }

                        &.step-2 {
                            stroke-dashoffset: 266;
                        }

                        &.step-3 {
                            stroke-dashoffset: 269.9;
                        }

                        &.step-4 {
                            stroke-dashoffset: 269.9;
                        }
                    }
                }

                .st-image-container {
                    position: absolute;
                    top: 50px;
                    left: 50%;
                    transform: translateX(-50%);

                    img {
                        -webkit-animation: hover 10s infinite ease-in-out;
                        -o-animation: hover 10s infinite ease-in-out;
                        animation: hover 10s infinite ease-in-out;
                        object-fit: contain;
                        height: 390px;
                    }
                }
            }

            .chart-indicator {
                @media only screen and (max-device-width: 768px) {
                    display: none;
                }

                &-mobile {
                    display: none;

                    &-indicator {
                        margin: 5px 0;

                        span,
                        p {
                            display: inline-block;
                            font-size: 36px;
                        }

                        span {
                            margin-right: 15px;
                            height: 36px;
                            width: 36px;
                            border-radius: 36px;
                        }

                        p {
                            margin: 0;
                        }
                    }

                    @media only screen and (max-device-width: 768px) {
                        display: block;
                        min-height: 220px;
                    }
                }
            }

        }

        .st-1-right-container {
            height: 410px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            width: 490px;

            @media only screen and (max-device-width: 768px) {
                width: 90%;
            }

            .st-1-story {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 75px;

                p {
                    width: 482px;
                    height: auto;
                    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.22);
                    font-size: 23px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    text-align: center;
                    color: #ffffff;
                }

                @media only screen and (max-device-width: 768px) {
                    margin-top: 0;
                    p {
                        width: 100%;
                        font-size: 36px;
                    }
                }
            }

            .story-button-container {
                width: auto;
                height: 90px;

                p {
                    width: auto;
                }

                @media only screen and (max-device-width: 768px) {
                    margin-top: 0;

                    .next-story {
                        font-size: 36px;
                    }
                    a {
                        min-height: 100px;
                        width: 668px;
                        p {
                            font-size: 30px;
                        }
                    }
                }
            }

            .blue-button {
                min-width: 380px;
                width: auto;
                margin: 0 auto;
            }
        }
        
        @media only screen and (max-width: 1024px) {
            padding-bottom: 55px;
        }

        @media only screen and (max-device-width: 768px) {
            &.view {
                flex-direction: column;
                width: 100%;
                flex-wrap: unset !important;
            }
        }
    }

</style>